import { render, staticRenderFns } from "./DisplayExtension.vue?vue&type=template&id=02cef793&scoped=true&"
import script from "./DisplayExtension.vue?vue&type=script&lang=js&"
export * from "./DisplayExtension.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02cef793",
  null
  
)

export default component.exports